import { HttpClient } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { PortalConsumption, PortalMe } from '../models/portal.models';

/**
 * Selbstauskunft des eingeloggten uVI-Kontakts (GET /portal/me) und seine
 * unterjährige Verbrauchsinformation (GET /portal/consumption). Die Ergebnisse
 * werden als Signals gehalten, damit Topbar und Seiten dieselbe Antwort teilen,
 * ohne die Endpunkte mehrfach zu rufen.
 */
@Injectable({
  providedIn: 'root',
})
export class PortalService {
  private readonly baseUrl = environment.apiUri + '/portal';
  private readonly meSignal = signal<PortalMe | null>(null);
  private readonly consumptionSignal = signal<PortalConsumption | null>(null);

  readonly me = computed(() => this.meSignal());
  readonly contact = computed(() => this.meSignal()?.contact ?? null);
  readonly uviContracts = computed(() => this.meSignal()?.uviContracts ?? []);
  readonly consumption = computed(() => this.consumptionSignal());

  constructor(private readonly http: HttpClient) {}

  loadMe(): Observable<PortalMe> {
    return this.http.get<PortalMe>(`${this.baseUrl}/me`).pipe(tap((me) => this.meSignal.set(me)));
  }

  loadConsumption(): Observable<PortalConsumption> {
    return this.http
      .get<PortalConsumption>(`${this.baseUrl}/consumption`)
      .pipe(tap((consumption) => this.consumptionSignal.set(consumption)));
  }
}
